(function () {
  var DASH_TEXT = '\u00A0–\u00A0';

  function reformatMoney(moneySpan) {
    var settings = window.coreexSettings || {};
    if (!settings.symbolFirst) return; // default order already fine, nothing to do

    var symbol = settings.currencySymbol || '€';
    var text = moneySpan.textContent.trim();
    var match = text.match(/[\d.,]+/); // grab just the numeric part
    if (!match) return;

    var desired = symbol + '\u00A0' + match[0];
    if (moneySpan.textContent.trim() !== desired) {
      moneySpan.textContent = desired;
    }
  }

  function ensureDashAndFormat(el) {
    var moneySpan = el.querySelector('.money');
    if (moneySpan) reformatMoney(moneySpan);

    var first = el.firstChild;
    var hasDash = first && first.nodeType === Node.TEXT_NODE && first.textContent.indexOf('–') !== -1;
    if (!hasDash) {
      el.insertBefore(document.createTextNode(DASH_TEXT), el.firstChild);
    }
  }

  function scan() {
    document.querySelectorAll('.coreex-atc-price').forEach(ensureDashAndFormat);
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });

  scan();
})();